import GeoJsonSource from 'src/services/geoJson/GeoJsonSource';

export default class PlaceBaseSource extends GeoJsonSource {
  /**
   * @returns {Object} A GeoJson source config object.
   */
  getConfig() {
    return Object.freeze({
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: [],
      },
    });
  }
}
